import styled from 'styled-components';

const TableWrapper = styled.div`
    padding: 0;
`;

export default TableWrapper;
